import { Pipe, PipeTransform } from '@angular/core';
import {NumberUtils} from '../utils/number-utils.class';

@Pipe({
  name: 'packingFormat'
})
export class PackingFormatPipe implements PipeTransform {

  transform(chemical: any): any {
    if (chemical && chemical.packingQuantity && chemical.packingUnit) {
      return `${chemical.code} - ${chemical.name} ${chemical.packingQuantity} ${chemical.packingUnit}/${chemical.packing}`;
    }
    else {
      return `${chemical.code} - ${chemical.name}`;
    }
    return '';
  }

}
